module.exports = __webpack_public_path__ + "img/shading-1.d5988fe8.png";